import { createFormAction } from 'redux-form-saga';

// Digimail status
export const SAGA_STATUS_CHECK = createFormAction('SAGA_STATUS_CHECK');

// Bank id
export const CANCEL_BANKID = 'CANCEL_BANKID';

// Session
export const SAGA_LOGIN = createFormAction('SAGA_LOGIN');
export const SAGA_LOGOUT = createFormAction('SAGA_LOGOUT');
export const SAGA_SESSION_GET = createFormAction('SAGA_SESSION_GET');

// Profile
export const SAGA_CUSTOMER_GET = createFormAction('SAGA_CUSTOMER_GET');
export const SAGA_CUSTOMER_POST = createFormAction('SAGA_CUSTOMER_POST');
export const SAGA_CUSTOMER_PUT = createFormAction('SAGA_CUSTOMER_PUT');
export const SAGA_CUSTOMER_DELETE = createFormAction('SAGA_CUSTOMER_DELETE');

// CMS
export const SAGA_TEXTS_GET = createFormAction('SAGA_TEXTS_GET');
export const SAGA_MEDIAS_GET = createFormAction('SAGA_MEDIAS_GET');

// Tags
export const SAGA_TAGS_GET = createFormAction('SAGA_TAGS_GET');

// Agreements
export const SAGA_AGREEMENT_GET = createFormAction('SAGA_AGREEMENT_GET');
export const SAGA_AGREEMENT_PUT = createFormAction('SAGA_AGREEMENT_PUT');

// Envelopes
export const SAGA_ENVELOPES_INBOX_GET = createFormAction('SAGA_ENVELOPES_INBOX_GET');
export const SAGA_ENVELOPES_ARCHIVES_GET = createFormAction('SAGA_ENVELOPES_ARCHIVES_GET');

export const SAGA_ENVELOPE_CONTENTS_GET = createFormAction('SAGA_ENVELOPE_CONTENTS_GET');
export const SAGA_ENVELOPE_ARCHIVE = createFormAction('SAGA_ENVELOPE_ARCHIVE');
export const SAGA_ENVELOPE_DELETE = createFormAction('SAGA_ENVELOPE_DELETE');

export const SAGA_ENVELOPE_CONTENT_INLINE_GET = createFormAction('SAGA_ENVELOPE_CONTENT_INLINE_GET');
export const SAGA_ENVELOPE_CONTENT_DOCUMENT_GET = createFormAction('SAGA_ENVELOPE_CONTENT_DOCUMENT_GET');

// Archives search
export const SAGA_ARCHIVES_SEARCH_GET = createFormAction('SAGA_ARCHIVES_SEARCH_GET');
export const ARCHIVES_SEARCH_CLEAR = 'ARCHIVES_SEARCH_CLEAR';

// Agencies
export const SAGA_GOVERNMENT_CONNECT_GET = createFormAction('SAGA_GOVERNMENT_CONNECT_GET');
export const SAGA_GOVERNMENT_CONNECT_POST = createFormAction('SAGA_GOVERNMENT_CONNECT_POST');
export const SAGA_GOVERNMENT_CONNECT_DELETE = createFormAction('SAGA_GOVERNMENT_CONNECT_DELETE');

export const SAGA_GOVERNMENT_LIST_GET = createFormAction('SAGA_GOVERNMENT_LIST_GET');
export const SAGA_GOVERNMENT_LIST_PUT = createFormAction('SAGA_GOVERNMENT_LIST_PUT');

// Companies
export const SAGA_COMPANY_GET = createFormAction('SAGA_COMPANY_GET');

// Support
export const SAGA_SUPPORT_POST = createFormAction('SAGA_SUPPORT_POST');

// Popup
export const POPUP_SHOW = 'POPUP_SHOW';
export const POPUP_HIDE_BANKID = 'POPUP_HIDE_BANKID';
export const POPUP_HIDE = 'POPUP_HIDE';

// Document types
export const PRESENTATION_TYPES = Object.freeze({ INLINE: 1, MOVIE: 2, EXTERNAL: 3, PREVIEW: 4 });
export const CONTENT_TYPES = Object.freeze({ TEXT: 'text/plain', HTML: 'text/html', PDF: 'application/pdf' });

// Bank id login methods
export const BANK_ID_TYPES = Object.freeze({ MOBILE: 'mobile', DESKTOP: 'desktop' });

// Email verification
export const SAGA_VERIFICATIONS = createFormAction('SAGA_VERIFICATIONS');



// WEBPACK FOOTER //
// ./src/misc/types.js